import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { type CampaignDetailsModalStore } from 'widgets/CampaignDetailsModal/store/campaignDetailsModalStore'
import { EnrollByWebhookCopyInput } from 'widgets/EnrollByWebhook/EnrollByWebhookCopyInput.tsx'
import { UiContactsTrigger } from './UiContactsTrigger'
import styles from './styles.module.scss'

export const EnrollContacts = observer(({ store }: { store: CampaignDetailsModalStore }) => {
  const { enrollByWebhookStore } = store

  return (
    <div className={styles.wrap}>
      {enrollByWebhookStore.isActive && enrollByWebhookStore.webhookUrl && (
        <div className={styles.block}>
          <Typography ariaLabel={'Webhook URL'} variant={'body-rg-medium'} className={styles.title}>
            Webhook URL
          </Typography>
          <EnrollByWebhookCopyInput
            webhookUrl={enrollByWebhookStore.webhookUrl}
            textFieldSize={'small'}
            copyBtnSize={'medium'}
          />
        </div>
      )}
      <div className={styles.block}>
        <Typography ariaLabel={'Send'} variant={'body-rg-medium'} className={styles.title}>
          Send
        </Typography>
        <div className={styles.grid}>
          <Typography ariaLabel={'Send'} variant={'text-input-field'} className={styles.label}>
            Contacts
          </Typography>
          <UiContactsTrigger
            total={store.enrolledContactsCount}
            skipped={store.skippedCount}
            wrapPlaceholderClassName={styles.wrapPlaceholderClassName}
            onClick={store.viewEnrollment}
          />
        </div>
      </div>
    </div>
  )
})
